var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddblue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 37,
    viewBox: "0 0 64 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 63.9879,
    height: 36.1222,
    rx: 16.513,
    fill: "#155DFC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.9146 18.9068H32.8399V23.9815H31.1484V18.9068H26.0737V17.2153H31.1484V12.1406H32.8399V17.2153H37.9146V18.9068Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddblue);
export default __webpack_public_path__ + "static/media/Addblue.ffec3cd51cfd9a33ae7af62029751ac5.svg";
export { ForwardRef as ReactComponent };